import { apiClient } from "@/services/apiClient";

export interface UserAddressDto {
  id: string;
  userId: string;
  label: string | null;
  isDefault: boolean;
  googlePlaceId: string | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  route: string | null;
  streetNumber: string | null;
  addressLine2: string | null;
  neighborhood: string | null;
  city: string | null;
  adminArea: string | null;
  postalCode: string | null;
  countryCode: string;
  contactPhone: string | null;
  contactPersonName: string | null;
  courierNotes: string | null;
  createdAt: string;
  updatedAt: string;
}

/** Payload for POST /me/addresses (aligned with backend CreateUserAddressDto). */
export interface UserAddressCreatePayload {
  /** Optional nickname (e.g. office, home). */
  label?: string;
  isDefault?: boolean;
  googlePlaceId?: string;
  formattedAddress?: string;
  latitude?: number;
  longitude?: number;
  route?: string;
  streetNumber?: string;
  /** Apartment, suite, unit, etc. */
  addressLine2?: string;
  neighborhood?: string;
  city?: string;
  adminArea?: string;
  postalCode?: string;
  countryCode?: string;
  contactPhone?: string;
  contactPersonName?: string;
  /** Courier instructions (optional); stored on the address for delivery flows. */
  courierNotes?: string;
}

export function listUserAddresses(): Promise<{ items: UserAddressDto[] }> {
  return apiClient.get<{ items: UserAddressDto[] }>("/me/addresses").then((res) => res.data);
}

export function createUserAddress(body: UserAddressCreatePayload): Promise<UserAddressDto> {
  return apiClient.post<UserAddressDto>("/me/addresses", body).then((res) => res.data);
}

export function updateUserAddress(
  id: string,
  body: Partial<UserAddressCreatePayload>,
): Promise<UserAddressDto> {
  return apiClient
    .patch<UserAddressDto>(`/me/addresses/${encodeURIComponent(id)}`, body)
    .then((res) => res.data);
}

export function deleteUserAddress(id: string): Promise<void> {
  return apiClient.delete(`/me/addresses/${encodeURIComponent(id)}`).then(() => undefined);
}
